import SEOHead from '@/components/SEOHead';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import CookieConsent from '@/components/CookieConsent';
import BackToTop from '@/components/BackToTop';
import ProjectBuilder from '@/components/builder/ProjectBuilder';
import AdminPanelShowcase from '@/components/AdminPanelShowcase';

export default function PricingPage() {
  return (
    <div className="min-h-screen bg-white dark:bg-[#0A0A0A] text-[#0A0A0A] dark:text-white transition-colors duration-300">
      <SEOHead
        title="Web Design Quote Builder | Custom Pricing | UI Designs"
        description="Build your custom web design quote in 5 steps. Foundation packages from £399, add bolt-ons, care plans, and hosting — live pricing, instant quote emailed within the hour."
        canonical="https://uidesigns.co.uk/pricing"
        keywords="web design quote builder, custom website pricing, web design packages Bournemouth, website cost calculator, care plans hosting Bournemouth"
      />
      <Navigation />
      <main className="pt-20 sm:pt-24 relative overflow-hidden">
        {/* Ambient glow kept to the bottom-right only so it doesn't wash the headline */}
        <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
          <div className="absolute top-[60vh] -right-40 w-[520px] h-[520px] rounded-full bg-violet-400/15 dark:bg-violet-500/10 blur-[120px]" />
          <div className="absolute bottom-0 left-1/3 w-[360px] h-[360px] rounded-full bg-[#00E5FF]/10 dark:bg-[#00E5FF]/5 blur-[100px]" />
        </div>
        <div className="relative pt-10 sm:pt-14">
          <ProjectBuilder />
        </div>
        <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
          <AdminPanelShowcase />
        </div>
      </main>
      <Footer />
      <CookieConsent />
      <BackToTop />
    </div>
  );
}
